import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WebConfigurationService } from '../web-configuration-module/web-configuration.service';
import { BaseService } from './base-service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DlpService extends BaseService {

  constructor(protected http: HttpClient, protected configurationService: WebConfigurationService) {
    super(http, configurationService, 'public/rest/v1', configurationService.configuration.dlpApi);
  }

  sendMortgageEmail(companyId: string, data: any): Observable<any> {
    return this.http.post(`${this.configurationService.configuration.dlpApi}public/rest/v1/email-service/send/${companyId}`, data);
  }
}
